import { Link } from 'react-router-dom'
import {
  HiOutlineGlobeAlt, HiOutlineDocumentText, HiOutlineSpeakerphone, HiOutlineClipboardList,
  HiOutlineChat, HiOutlineBell, HiOutlineSearch, HiOutlineStar, HiOutlineUsers,
  HiOutlineChartBar, HiOutlineTrash, HiOutlineRefresh, HiOutlineMail, HiOutlineLocationMarker,
  HiOutlineLogin, HiOutlineArrowRight, HiOutlineCheckCircle,
} from 'react-icons/hi'

const FEATURES = [
  { icon: HiOutlineGlobeAlt, title: 'Trang tuyển dụng online', desc: 'Trang giới thiệu công ty + form ứng tuyển đẹp, chạy tốt trên điện thoại. Ứng viên điền thông tin và tải CV trực tiếp.' },
  { icon: HiOutlineSpeakerphone, title: 'Chiến dịch riêng cho từng người', desc: 'Mỗi nhân viên tự tạo link tuyển dụng riêng. Ứng viên nộp qua link của ai thì hồ sơ tự về tay người đó — không cần chờ chia.' },
  { icon: HiOutlineDocumentText, title: 'Quản lý hồ sơ tập trung', desc: 'Mọi hồ sơ ứng viên gom về một nơi: tên, SĐT, khu vực, vị trí, CV… Không còn quản lý bằng Excel rời rạc.' },
  { icon: HiOutlineClipboardList, title: '18 trạng thái xử lý', desc: 'Theo dõi ứng viên theo từng bước: mới → đang trao đổi → hẹn phỏng vấn → nhận việc… Gom thành 4 nhóm dễ nhìn.' },
  { icon: HiOutlineLocationMarker, title: 'Nhận biết nguồn tự động', desc: 'Hệ thống tự biết ứng viên đến từ đâu: Facebook Ads, Zalo, Google, TikTok hay website — để đo kênh nào hiệu quả.' },
  { icon: HiOutlineChat, title: 'Nhật ký tư vấn (bình luận)', desc: 'Mỗi lần gọi/nhắn ứng viên, ghi lại một dòng vào hồ sơ. Cả nhóm cùng thấy lịch sử chăm sóc, không sợ trùng hay bỏ sót.' },
  { icon: HiOutlineBell, title: 'Thông báo thông minh', desc: 'Chuông báo: hồ sơ cần xử lý, quá hẹn gọi lại, và khi có người bình luận vào hồ sơ bạn phụ trách.' },
  { icon: HiOutlineSearch, title: 'Tìm kiếm & lọc nhanh', desc: 'Tìm theo mã hồ sơ, tên, số điện thoại, email. Lọc theo trạng thái, nguồn, khu vực, người phụ trách, thời gian.' },
  { icon: HiOutlineStar, title: 'Ghim hồ sơ cần chú ý', desc: 'Đánh dấu sao những ứng viên quan trọng để tìm lại nhanh — riêng cho mỗi người, không ảnh hưởng người khác.' },
  { icon: HiOutlineUsers, title: 'Phân quyền & phân luồng', desc: '4 vai trò rõ ràng. Trưởng phòng/nhóm chia hồ sơ cho nhân viên; nhân viên chỉ thấy hồ sơ của mình.' },
  { icon: HiOutlineChartBar, title: 'Báo cáo & thống kê', desc: 'Xem tổng hồ sơ, tỉ lệ chuyển đổi theo phễu, theo khu vực, theo nhân viên. Xuất file để báo cáo.' },
  { icon: HiOutlineTrash, title: 'Lịch sử xóa (chống gian lận)', desc: 'Mọi lần xóa hồ sơ đều được lưu lại: ai xóa, khi nào, lý do — minh bạch, dễ truy vết.' },
  { icon: HiOutlineRefresh, title: 'Đồng bộ dữ liệu', desc: 'Nhận hồ sơ từ website chính của công ty và đồng bộ từ Google Sheet — dữ liệu tự chảy về, không phải nhập tay.' },
  { icon: HiOutlineMail, title: 'Email báo hồ sơ mới', desc: 'Có ứng viên mới là hệ thống gửi email cho người phụ trách ngay — không bỏ lỡ ứng viên nào.' },
]

const STEPS = [
  { t: 'Ứng viên nộp hồ sơ', d: 'Qua trang tuyển dụng hoặc link chiến dịch, kèm CV.' },
  { t: 'Hồ sơ về hệ thống', d: 'Tự động ghi nhận nguồn và (nếu qua link riêng) tự gán người phụ trách.' },
  { t: 'Phân công', d: 'Trưởng phòng/nhóm chia hồ sơ cho nhân viên tư vấn phù hợp.' },
  { t: 'Tư vấn & ghi nhật ký', d: 'Gọi/nhắn ứng viên, ghi lại từng lần vào hồ sơ; hẹn gọi lại sẽ được nhắc.' },
  { t: 'Cập nhật trạng thái', d: 'Đổi trạng thái theo tiến độ tới khi hẹn PV, nhận việc — hoặc kết thúc.' },
]

const ROLES = [
  { r: 'Trưởng phòng / Admin', d: 'Toàn quyền: xem tất cả, báo cáo, cấu hình, quản lý tài khoản.' },
  { r: 'Quản lý (Trưởng phòng NS)', d: 'Xem tất cả hồ sơ, phân công, thống kê.' },
  { r: 'Trưởng nhóm', d: 'Quản lý hồ sơ của nhóm mình, chia việc cho nhân viên, kiêm tư vấn.' },
  { r: 'Nhân viên', d: 'Xử lý các hồ sơ được giao, ghi nhật ký tư vấn, tự tạo chiến dịch riêng.' },
]

export default function Guide() {
  return (
    <div className="min-h-screen bg-brand-50 text-brand-900">
      {/* Header */}
      <header className="bg-gradient-to-br from-brand-700 to-brand-500 text-white">
        <div className="max-w-5xl mx-auto px-5 py-12 sm:py-16">
          <div className="flex items-center gap-3 mb-6">
            <img src="/logo-dxmt.png" alt="DXMT" className="h-11 w-auto bg-white rounded-lg p-1" onError={(e) => { e.currentTarget.style.display = 'none' }} />
            <span className="font-semibold tracking-wide">ĐẤT XANH MIỀN TRUNG</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold leading-tight">Hệ thống Quản lý Tuyển dụng</h1>
          <p className="mt-3 text-brand-100 text-lg max-w-2xl">
            Công cụ giúp phòng Nhân sự thu hút, quản lý và chăm sóc ứng viên tập trung — từ lúc nộp hồ sơ đến khi nhận việc.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/login" className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white font-medium px-5 py-2.5 rounded-lg transition">
              <HiOutlineLogin className="w-5 h-5" /> Đăng nhập hệ thống
            </Link>
            <Link to="/" className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-medium px-5 py-2.5 rounded-lg transition">
              Xem trang tuyển dụng <HiOutlineArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-5 py-12 space-y-14">
        {/* Tổng quan */}
        <section>
          <h2 className="text-xl font-bold mb-5">Hệ thống giúp được gì?</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              ['📥', 'Thu hút ứng viên', 'Trang tuyển dụng + link chiến dịch riêng cho từng người.'],
              ['🗂️', 'Quản lý tập trung', 'Mọi hồ sơ & CV gom một nơi, thay cho Excel.'],
              ['📞', 'Chăm sóc bài bản', 'Nhật ký tư vấn, nhắc hẹn, thông báo real-time.'],
              ['📊', 'Đo lường hiệu quả', 'Báo cáo theo nguồn, khu vực, nhân viên.'],
            ].map(([e, t, d]) => (
              <div key={t} className="bg-white rounded-xl p-5 shadow-sm border border-brand-100">
                <div className="text-2xl mb-2">{e}</div>
                <div className="font-semibold text-brand-800">{t}</div>
                <div className="text-sm text-brand-900/60 mt-1">{d}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Tính năng chi tiết */}
        <section>
          <h2 className="text-xl font-bold mb-1">Các tính năng chính</h2>
          <p className="text-brand-900/60 mb-5">Tất cả đều thao tác bằng giao diện, không cần biết kỹ thuật.</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {FEATURES.map(({ icon: Icon, title, desc }) => (
              <div key={title} className="bg-white rounded-xl p-5 shadow-sm border border-brand-100 hover:shadow-md transition">
                <div className="w-10 h-10 rounded-lg bg-brand-50 text-brand-600 flex items-center justify-center mb-3">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="font-semibold text-brand-800">{title}</div>
                <div className="text-sm text-brand-900/60 mt-1 leading-relaxed">{desc}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Quy trình */}
        <section>
          <h2 className="text-xl font-bold mb-5">Quy trình xử lý một ứng viên</h2>
          <ol className="space-y-3">
            {STEPS.map((s, i) => (
              <li key={s.t} className="flex gap-4 bg-white rounded-xl p-4 shadow-sm border border-brand-100">
                <div className="shrink-0 w-9 h-9 rounded-full bg-brand-600 text-white font-bold flex items-center justify-center">{i + 1}</div>
                <div>
                  <div className="font-semibold text-brand-800">{s.t}</div>
                  <div className="text-sm text-brand-900/60">{s.d}</div>
                </div>
              </li>
            ))}
          </ol>
        </section>

        {/* Vai trò */}
        <section>
          <h2 className="text-xl font-bold mb-5">Vai trò & phân quyền</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {ROLES.map((x) => (
              <div key={x.r} className="bg-white rounded-xl p-5 shadow-sm border border-brand-100 flex gap-3">
                <HiOutlineCheckCircle className="w-6 h-6 text-brand-500 shrink-0 mt-0.5" />
                <div>
                  <div className="font-semibold text-brand-800">{x.r}</div>
                  <div className="text-sm text-brand-900/60">{x.d}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="bg-gradient-to-br from-brand-700 to-brand-500 rounded-2xl text-white px-6 py-10 text-center">
          <h2 className="text-2xl font-bold">Sẵn sàng bắt đầu?</h2>
          <p className="text-brand-100 mt-2">Đăng nhập bằng tài khoản được cấp để vào khu vực quản lý.</p>
          <Link to="/login" className="inline-flex items-center gap-2 mt-5 bg-accent-500 hover:bg-accent-600 text-white font-medium px-6 py-3 rounded-lg transition">
            <HiOutlineLogin className="w-5 h-5" /> Đăng nhập hệ thống
          </Link>
        </section>
      </main>

      <footer className="border-t border-brand-100 py-6 text-center text-sm text-brand-900/50">
        © Đất Xanh Miền Trung — Hệ thống Quản lý Tuyển dụng nội bộ.
      </footer>
    </div>
  )
}
